export default "__VITE_ASSET__dBdtfk41__"